// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e9Kw","col":"styles_col__2vjAC"};